export default __webpack_public_path__ + "static/media/our-service-commercial-content.08dacef9.jpg";